<template>
  <el-dialog :append-to-body="true" id="back-seal-layer" title="撤回授权" :visible.sync="dialogVisible" width="450px" :center="true">
    <div class="seal-box">
      <img :src="sealData" alt="">
    </div>
    <div class="dialog-btns">
      <el-button type="primary" @click="backSealHandle" class="btn-ok">确认</el-button>
      <el-button type="info" @click="cancelHandle" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { showAuthInfoApi, backSealApi } from '@/api/space/authorize'
import { mapState } from 'vuex'
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      sealData: '',
      sealId: '',
      userId: '',
      dialogVisible: false,
      messageId: ''
    }
  },
  computed: mapState([
    'currentSpace'
  ]),
  methods: {
    showSealInfoHandle() {
      showAuthInfoApi({
        messageId: this.messageId
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.sealData = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API)+res.data.message.sealData+getToken()
        }
      })
    },
    backSealHandle() {
      backSealApi({
        userId: this.userId,
        sealId: this.sealId,
        companyId: this.currentSpace.companyId
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.$message({
            showClose: true,
            message: '撤回成功！',
            type: 'success'
          });
          this.$parent.init()
          this.cancelHandle()
        }
      })
    },
    cancelHandle() {
      this.dialogVisible = false
      this.messageId = ''
      this.sealData = ''
    }
  }
}
</script>
<style scoped>
  .seal-box{
    width: 300px;
    height: 300px;
    border:1px solid rgba(229,229,229,1);
    border-radius:10px;
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .seal-box img {
    max-width: 290px;
    max-height: 290px;
    display: block;
  }

  .dialog-btns{
    width: 380px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
  }
</style>